export const AUTH_LOGIN = "auth_login"
export const AUTH_SIGNUP = "auth_signup"
export const AUTH_FORGOT_PASSWORD = "auth_forgot_password"


export const JOURNEY_LOGIN_NORMAL= "ALDAR EDUCATION USER EMAIL LOGIN WEB"
export const JOURNEY_REGISTER = "ALDAR EDUCATION USER REGISTRATION"
export const JOURNEY_CHANGE_PASSWORD ="ALDAR EDUCATION USER CHANGE PASSWORD"
export const JOURNEY_FORGET_PASSWORD ="ALDAR EDUCATION USER FORGET PASSWORD"

export const LOGIN_SUCCESS= "LoginSuccess";
export const LOGIN_FAILURE= "LoginFailure";
export const LOGIN_LIMIT_EXCEEDED= "OTP Limit Exceeded"
export const NEW_PASSWORD="New Password"
export const RESET_PASSWORD="Reset Password"
export const OTP="OTP"
export const REOTP="REOTP"
export const USERNAME="userName"
export const RETRY= "retry";
export const TIMEOUT = "timeout"
export const AUTH_ERROR = "authorization error"

export const INVALID_LOGIN= "Invalid Username/Password"
export const INVALID_EXISTING_PWD = "Invalid Existing Password"
export const INVALID_OTP= "OTP is invalid."
export const INVALID_OTP2= "OTP is invalid"
export const USER_EXITS = "Your account already exists. please login."
export const USER_LOCKED_OUT = "User Locked Out."

export const FAILED= "failed"
export const ERROR= "error"
export const STEP= "Step"
export const GIVEN_NAME="givenName"

export const DASHBOARD ="dashboard"
export const APPLICATION ="application"
export const PROFILE ="profile"
export const UPDATE_PASSWORD ="updatePassword"
export const CHANGE_PASSWORD= "changePassword"

export const UNAUTHORIZED= "UNAUTHORIZED"
export const SUCCESS= "Success"